import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TaskService, SERVICE_CONFIG } from '../../services/task.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-ratio-superisory',
  templateUrl: './ratio-superisory.component.html',
  styleUrls: ['./ratio-superisory.component.css']
})
export class RatioSuperisoryComponent implements OnInit {
  color = {
    'remind': '#FFFADA',
    'warn': '#FF8189',
  };

  dataList = [];

  tableWidth = 0;
  tableData: any = [];
  executionId: any;

  page = {
    page: 1,
    rows: 20,
    total: 0
  };
  countHeight = 400;
  layerHeight = 610;
  pageLoading = false;

  tableFooter: any = [];
  title = {
    source1: 0,
    source2: 0
  };
  formTemplate = {
    "form": {
      "autoComplete": "off",
      "groupStyle": "default",
      "labelNewLine": false,
      "formCollapsed": 2
    },
    "properties": [
      // {
      //   "type": "input",
      //   "label": "姓名",
      //   "name": "name",
      //   "items": 3,
      //   "labelCol": 6,
      //   "controlCol": 18
      // },
      // {
      //   "type": "textRange",
      //   "label": "区间字段",
      //   "name": "phone",
      //   "items": 3,
      //   "labelCol": 6,
      //   "controlCol": 18
      // },
      // {
      //   "type": "select",
      //   "label": "邮箱",
      //   "name": "email",
      //   "items": 3,
      //   "labelCol": 6,
      //   "controlCol": 18,
      //   "serverConfig": {
      //     "option": {
      //       "1": '选项1',
      //       "2": '选项2',
      //       "3": '选项3',
      //       "4": '选项4',
      //     },
      //   }
      // }
    ]
  };
  isQueryLoading = false;
  params = {};
  environment = {};
  formCollapsed = 2;           // 查询区域默认显示2行
  isQueryCollapsed = true;    // 查询区域是否展开

  warnedVisible = false;

  datasourceId = '';
  columsList: any = [];

  //保存模板
  addTemplateVisible = false;
  templateForm = this.fb.group({
    name: ['', Validators.required]
  });

  // 预览
  viewVisible = false;
  viewHead: any = [];
  viewTableWidth = 400;
  submitViewData: any = {};
  sendLoading = false;

  itemId: any = "";

  // 发送提醒数据
  ids: any = [];
  warnedData: any = {};
  searchConidtion: any = {}; // 查询条件
  selfDefValue: any = [];
  viewData: any = {};

  // 选择数据
  checkedData: any = [];

  templateLoading = false;

  // 外部稽核
  source: string = null;
  outSystemCode: string = null; // 外部系统编码
  outItemId: string = null; // 外部稽核ID

  @ViewChild('queryForm') queryForm: any;
  @ViewChild('warnedComponent') warnedComponent;
  constructor(
    private message: NzMessageService,
    private taskService: TaskService,
    private modalServer: NzModalService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    this.environment = SERVICE_CONFIG.environment;
    this.countHeight = document.body.clientHeight - 400;
    this.layerHeight = this.countHeight + 260;
  }

  listenerScroll() {
    setTimeout(() => {
      document.querySelector('.table-left .ant-table-body').addEventListener('scroll', (e: any) => {
        if (document.querySelector('.table-left .source1-footer .ant-table-body')) {
          document.querySelector('.table-left .source1-footer .ant-table-body').scrollLeft = e.target.scrollLeft;
          document.querySelector('.table-left .source1-footer .ant-table-body').scrollTop = e.target.scrollTop;
        }
      });
    }, 1000);
  }

  // 获取表头数据
  getColumsList() {
    this.page.page = 1;
    this.taskService.getIndicatorHeadList(this.executionId).subscribe(res => {
      const template = JSON.parse(JSON.stringify(this.formTemplate));
      template.properties = res['searchCondition'] ? res['searchCondition'] : [];
      this.formTemplate = template;
      this.columsList = res && res['columns'] ? res['columns'] : [];
      this.tableWidth = this.columsList.length * 200 + 50;
      this.getDataList();
    });
  }

   // 获取列表数据
   getDataList() {
    this.pageLoading = true;
    const params = JSON.parse(JSON.stringify(this.params));
    for (const key in params) {
      if (typeof params[key] === 'object') {
        delete params[key];
      }
    }
    const param = {
      page: this.page.page,
      rows: this.page.rows,
      ...params
    };
    this.taskService.getIndicatorExecutionsList(this.executionId, param).subscribe(res => {
      this.pageLoading = false;
      this.isQueryLoading = false;
      this.tableData = res && res['_embedded'] && res['_embedded'].vos ? res['_embedded'].vos : [];
      this.page.total = res ? res['page'].totalElements : 0;
    }, ( () => {
      this.pageLoading = false;
      this.isQueryLoading = false;
    }));
  }

  // 获取总记录数
  getTotal() {
    const params = JSON.parse(JSON.stringify(this.params));
    for (const key in params) {
      if (typeof params[key] === 'object') {
        delete params[key];
      }
    }
    this.taskService.getIndicatorTotalData(this.executionId, params).subscribe( res => {
      this.getStatistic(res ? res : {});
    });
  }

  getStatistic(data) {
    this.tableFooter = [];
    if (data && data.length) {
      const statistics = data;
      const obj = {};
      statistics.forEach( item => {
        obj[item.code] = item.value;
      });
      this.tableFooter.push(obj);
    }
  }

  // 查询区域展开收缩
  queryCollapse() {
    this.isQueryCollapsed = !this.isQueryCollapsed;
  }

  // 页码改变
  changePage(e) {
    this.page.page = e;
    this.getDataList();
  }

  // 页码条数改变
  changeSize(e) {
    this.page.rows = e;
    this.page.page = 1;
    this.getDataList();
  }

  // 提醒-确定
  warnedSubmit() {
    const data = this.warnedComponent.getSubmitForm();
    if (data) {
    }
  }

  // 关闭发送提醒
  warnedCancel(isTip?) {
    if (isTip) {
      this.modalServer.confirm({
        nzTitle: '关闭提示',
        nzContent: '弹框关闭之后填写数据将丢失，请确认是否关闭？',
        nzWrapClassName: 'vertical-center-modal',
        nzOnOk: () => {
          this.warnedVisible = false;
        }
      });
    } else {
      this.warnedVisible = false;
    }
  }

  initWarnedField() {
    if (this.source === 'out') {
      this.taskService.getOutIndicatorItemColumns(this.outSystemCode, this.outItemId, this.itemId).subscribe((vos: any) => {
        // 监控指标
        const outItemColumns = vos;
        this.warnedComponent.getOutIndicatorList(outItemColumns);
      });
    } else {
      // 内部监控
      this.warnedComponent.getList(this.datasourceId);
    }
  }

  // 搜索
  searchHandle(event) {
    this.isQueryLoading = true;
    this.queryForm.handleSubmit(event);
  }

  // 清空
  emptyForm() {
    this.queryForm.resetForm();
  }

  doSubmit(event) {
    this.params = event;
    this.getDataList();
    this.getTotal();
  }
  // 查询条件回车
  enterQuery(event) {
    this.isQueryLoading = true;
    // 长时间没得到父组件传入数据，自动停止
    this.queryForm.handleSubmit(event);
  }
  // excel导出
  exportHandle() {
    const param = JSON.parse(JSON.stringify(this.params));
    for (const key in param) {
      if (typeof param[key] === 'object') {
        delete param[key];
      }
    }
    this.taskService.exportIndicatorExcel(param, this.executionId);
  }
  // 保存模板
  addOprate() {
    this.templateForm.reset();
    const data = this.warnedComponent.getSubmitForm();
    if (data) {
      this.addTemplateVisible = true;
    }
  }
  // 保存模板-确定
  addSubmit() {
    if (this.templateForm.get('name').value && !this.templateForm.get('name').value.trim()) {
      this.templateForm.get('name').patchValue('');
    }
    for (const key in this.templateForm.controls) {
      this.templateForm.controls[key].markAsDirty();
      this.templateForm.controls[key].updateValueAndValidity();
    }
    if (this.templateForm.valid) {
      this.templateLoading = true;
      const data = JSON.parse(JSON.stringify(this.warnedComponent.getSubmitForm()));
      data['name'] = this.templateForm.get('name').value;
      this.taskService.addIndicatorNoticeTemplate(this.itemId, data).subscribe( res => {
        this.message.success('保存模板成功！');
        this.templateLoading = false;
        this.addTemplateVisible = false;
      }, () => {
        this.templateLoading = false;
      });
    }
  }
  // 保存模板-取消
  cancleSubmit() {
    this.addTemplateVisible = false;
  }
  // 预览
  viewOprate() {
    const data = this.warnedComponent.getSubmitForm();
    this.warnedData = data;
    if (data) {
      this.viewVisible = true;
      this.viewHead = data.bodyDetail ? data.bodyDetail : [];
      this.viewTableWidth = this.viewHead && this.viewHead.length ? this.viewHead.length * 200 : 400;
      const params = {
        ids: this.ids,
        searchConidtion: this.params,
        recipient: this.warnedData.recipient,
        ccRecipient: this.warnedData.ccRecipient,
        subject: this.warnedData.subject,
        body: this.warnedData.body
      };
      this.selfDefValue = this.warnedData.selfDefValue
      if (!this.selfDefValue || !this.selfDefValue.length) {
        this.taskService.editListData(this.executionId, {ids: this.ids, bodyDetail: this.viewHead}).subscribe( res => {
          this.selfDefValue = res ? res : [];
        });
      }
      this.taskService.sendReviewOprate(this.executionId, params).subscribe( res => {
        const _data = res;
        this.submitViewData = _data;
        this.viewData['recipient'] = _data['recipient'].join(';');
        this.viewData['ccRecipient'] = _data['ccRecipient'].join(';');
        this.viewData['subject'] = _data['subject'];
        this.viewData['body'] = _data['body'];
      });
    }
  }
  // 预览-关闭
  viewCancel() {
    this.viewVisible = false;
  }
  // 获取邮件模板
  getTemplate() {
    this.warnedComponent.getEmailTemplate(this.itemId);
  }
  // 预览-发送
  sendOprate() {
    this.sendLoading = true;
    const params = {
      ...this.submitViewData,
      bodyDetail: this.viewHead,
      selfDefValue: this.selfDefValue,
    }
    this.taskService.sendConfirmOprate(this.executionId, params).subscribe( res => {
      this.message.success('发送成功！');
      this.viewCancel();
      this.warnedVisible = false;
      this.tableData.forEach( item => {
        item['checked'] = false;
      });
      this.checkedData = [];
      this.sendLoading = false;
    }, () => {
      this.sendLoading = false;
    });
  }
  // 选中数据
  checkedOprate(data) {
    if (data['checked']) {
      this.checkedData.push(data);
    } else {
      const index = this.checkedData.findIndex( item => item.id === data.id);
      this.checkedData.splice(index, 1);
    }
  }
  // 获取选中数据id
  getCheckedId() {
    const ids = [];
    if (this.checkedData && this.checkedData.length) {
      this.checkedData.forEach( item => {
        ids.push(item.id);
      });
      return ids;
    } else {
      this.message.warning('请先选择数据！');
      return [];
    }
  }
}
